<template>
  <div :class="[$style.wrapper, alignment === 'horizontal' ? $style.horizontal : $style.vertical, $style[size]]">
    <div :class="[$style.icon, lightIconBg && 'bg-white mix-blend-normal']">
      <coffee-icon />
    </div>

    <div :class="$style.content">
      <div class="text-gray-80 mb-4 font-medium" :class="$style.title">
        <slot name="title">{{ title }}</slot>
      </div>
      <div :class="$style.subtitle">
        <slot name="subtitle">{{ subtitle }}</slot>
      </div>
      <div v-if="$slots.action" :class="$style.action">
        <slot name="action"></slot>
      </div>
      <div v-if="$slots.link" :class="$style.link">
        <slot name="link"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineComponent } from 'vue'
import { CoffeeIcon } from '@klausapp/ui-kit/icons'

withDefaults(
  defineProps<{
    title?: string
    subtitle?: string
    alignment?: 'vertical' | 'horizontal'
    size?: 'small' | 'medium'
    lightIconBg?: boolean
  }>(),
  {
    title: '',
    subtitle: '',
    alignment: 'vertical',
    size: 'medium',
  },
)

defineComponent({
  name: 'UiEmptyStateV2',
})
</script>

<style lang="scss" module>
.wrapper {
  --title-size: 20px;
  --subtitle-size: 14px;
  --icon-size: 32px;
  --icon-gap: 24px;
  --icon-stroke: 2.4px;
  --action-gap: 32px;
  --link-gap: 16px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--icon-gap);
}

.horizontal {
  flex-direction: row;

  .content {
    align-items: flex-start;
  }

  &.small {
    flex-direction: column;
    align-items: flex-start;
  }
}

.vertical {
  text-align: center;
}

.small {
  --title-size: 16px;
  --subtitle-size: 12px;
  --action-gap: 16px;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(var(--icon-size) * 2);
  width: calc(var(--icon-size) * 2);
  background-color: var(--gray-10);
  color: var(--gray-50);
  border-radius: 50%;
  mix-blend-mode: multiply;
  flex-shrink: 0;

  svg {
    height: var(--icon-size);
    width: var(--icon-size);
    stroke-width: var(--icon-stroke);
  }

  svg * {
    vector-effect: non-scaling-stroke;
  }
}

.title {
  font-size: var(--title-size);
}

.subtitle {
  font-size: var(--subtitle-size);
  font-weight: 500;
  color: var(--gray-60);
}

.action {
  margin-top: var(--action-gap);
  font-size: var(--subtitle-size);
}

.link {
  margin-top: var(--link-gap);
  font-size: var(--subtitle-size);
}
</style>
